/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const reserveSettingsSchema = z
	.object({
		slot_step_minutes: z.int(),
		default_duration_minutes: z.int(),
		min_lead_time_minutes: z.int(),
		max_days_in_advance: z.int(),
		max_active_per_user: z.int(),
		gap_minutes: z.int(),
		banquet_prepayment_percent: z.int(),
		banquet_prepayment_minutes: z.int(),
	})
	.describe("Настройки бронирования точки: нужны фронту для формы брони.");
